import { FlexColumn, useMoment } from '@gorila-shared-ui/components';
import { useMemo } from 'react';
import { JOBS_STATUS_CODES } from '../../constants/jobs';
import { useStyles } from '../../hooks/useStyles';
import { TimelineEvent } from '../../types/app';
import { Job } from '../../types/jobs';
import Timeline from '../ui/Timeline';

type Props = {
  job: Job;
};
export function JobHistory({ job }: Readonly<Props>) {
  const { css, theme } = useStyles();
  const { formatDateFromTs } = useMoment();

  const events: TimelineEvent[] = useMemo(() => {
    const finishedActivities = job.activities?.filter((activity) => !!activity.finishedDate) || [];
    const finishedActivitiesEvents = [
      {
        label: 'Creado',
        date: job.created ? formatDateFromTs(job.created, 'DD/MM/yyyy HH:mm:ss') : '-',
      },
      ...finishedActivities.map((activity) => ({
        label: activity.name,
        date: formatDateFromTs(activity.finishedDate, 'DD/MM/yyyy HH:mm:ss'),
      })),
    ];
    if (job.status?.statusType === JOBS_STATUS_CODES['cancelled'] && !!job.finishedDate) {
      finishedActivitiesEvents.push({
        label: 'Cancelado',
        date: formatDateFromTs(job.finishedDate, 'DD/MM/yyyy HH:mm:ss'),
      });
    }
    if (job.status?.statusType === JOBS_STATUS_CODES['closed_with_failed_visit'] && !!job.finishedDate) {
      finishedActivitiesEvents.push({
        label: 'Visita fallida',
        date: formatDateFromTs(job.finishedDate, 'DD/MM/yyyy HH:mm:ss'),
      });
    }
    return finishedActivitiesEvents;
  }, [job]);

  return (
    <FlexColumn
      gap={theme.sizing.scale200}
      classNames={css({ flex: 1, padding: theme.sizing.scale600 })}
    >
      <Timeline events={events} />
    </FlexColumn>
  );
}
